/** Story rails stay readable only while each page keeps a few pixels of its own; pages beyond this get no segment. */
export const MAX_STORY_PROGRESS_SEGMENTS = 6;

export interface StoryProgressRailProps {
  numberOfPages: number;
}
